module.exports = __webpack_public_path__ + "img/video_play.2711fb45.svg";